import { Colors } from '../Constant/Colors';
import fmt from "indian-number-format";
export const randomKey = () => {
  const crypto = window.crypto || window.msCrypto;
  const myArray = new Uint32Array(10);
  let randomCode = crypto.getRandomValues(myArray).toString().substring(2, 10);

  return randomCode;
};


export const checkRowStatus=(amt)=> {
  if (amt == undefined) {
    return Colors.grey;
  }
  return (typeof amt == "string" && amt != '') ?  Colors.red : Colors.white 
}
export const displayValue  =(amt) => {
  if(amt==0){
    return amt
  }
  
  if(!amt){
    return ""
  }
//  let newamout =  typeof amt == "number" ? amt.toLocaleString('en-IN') :  parseInt(amt).toLocaleString('en-IN')
  let cleanedAmt = typeof amt === "string" ? amt.replace(/,/g, '') : amt;
  // Parse the cleaned amount to a number
  let parsedAmt = parseFloat(cleanedAmt);
  // Format the number to the Indian numbering system with 2 decimal places
  let newAmount = parsedAmt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

 // console.log('newamout',newAmount)
  return newAmount // amt;
}
export function isDifferenceMoreThanYears(date1, date2, years) {
  // Calculate the difference in milliseconds
  var differenceMs = date1.getTime() - date2.getTime()
  // var differenceMs = Math.abs(date1 - date2);
  // Convert milliseconds to years
  var millisecondsPerYear = 1000 * 60 * 60 * 24 * 365; // accounting for leap years
  
  var differenceYears = differenceMs / millisecondsPerYear;
  // console.log("differenceMs",date1.getTime(),date2.getTime(),millisecondsPerYear,differenceYears,date1,date2,years)
  // Check if the difference is more than the specified number of years
  return differenceYears >= years;
};

// export function isDifferenceMoreThanYears(date1, date2, years) {
//   // Ensure we're working with Date objects
//   const d1 = new Date(date1);
//   const d2 = new Date(date2);

//   // Get the absolute year difference using getFullYear()
//   const yearDifference = Math.abs(d2.getFullYear() - d1.getFullYear());

//   // If the years are different, check the exact dates to refine the difference
//   if (yearDifference > 0) {
//     const earlier = d1 < d2 ? d1 : d2;
//     const later = d1 > d2 ? d1 : d2;

//     const yearBoundary = new Date(later.getFullYear(), earlier.getMonth(), earlier.getDate());
    
//     if (later < yearBoundary) {
//       return (yearDifference - 1) > years;
//     }
//   }

//   return yearDifference > years;
// }


